module.exports = __webpack_public_path__ + "static/media/image (7).b1acc331.jpg";